export default __webpack_public_path__ + "static/media/img-0614-monaco-full-face.cef4fd30.png";